import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import {
  defaultDateDisplay,
  formatCurrency,
  truncateString,
} from "../../../../helpers";
import { v4 as uuidv4 } from "uuid";
import useRestockLogDetails from "./useRestockLogDetails";
import { Link } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import secondaryComponents from "../..";

export const RestockLogDetails = ({ selectedProduct }) => {
  const { businessDetails, handleViewSupplier } = useRestockLogDetails({
    selectedProduct,
  });

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <div
        className={`${globalStyles.cardWithBorder} ${globalStyles.gridDetailsView}`}
      >
        <div>
          <p className="small-text-size">Restock Date/Time:</p>
          <p className="small-text-size dark--text font-weight-normal mt-2">
            {selectedProduct?.created_at
              ? defaultDateDisplay(selectedProduct?.created_at)
              : "N/A"}
          </p>
        </div>
        <div>
          <p className="small-text-size">Restocked By:</p>
          <p className="small-text-size dark--text font-weight-normal mt-2">
            {selectedProduct?.submitted_by?.first_name || "N/A"}
          </p>
        </div>
        <div>
          <p className="small-text-size">Store :</p>
          <p className="small-text-size dark--text font-weight-normal mt-2">
            {selectedProduct?.stores?.length > 1 ? (
              <span>
                <secondaryComponents.ToolTip
                  placeholderContent="Multiple Stores"
                  showInfoIcon
                  useContentStyling
                  contentStyles={{
                    width: "100%",
                    maxWidth: "200px",
                    padding: "15px",
                  }}
                >
                  <span
                    className={`${globalStyles.rowSpaceBetween} ${globalStyles.borderBottom} pb-2`}
                  >
                    <p className="small-text-size">Store Name</p>
                  </span>

                  {/* Store list */}
                  <span>
                    {selectedProduct?.stores?.map((store) => (
                      <div
                        className={`${globalStyles.rowSpaceBetween} ${globalStyles.borderBottom} pt-2 pb-2`}
                        key={uuidv4()}
                      >
                        <p className="smallest-text-size">
                          {truncateString(store?.name, 20)}
                        </p>
                      </div>
                    ))}
                  </span>
                </secondaryComponents.ToolTip>
              </span>
            ) : (
              <span className="small-text-size dark--text font-weight-normal">
                {selectedProduct?.stores?.[0]?.name || "N/A"}
              </span>
            )}
          </p>
        </div>
        <div>
          <p className="small-text-size">Restock Type:</p>
          <p
            className="small-text-size dark--text font-weight-normal mt-2"
            style={{
              background: "#EFEFEF",
              color: "#696677",
              borderRadius: "15px",
              padding: "5px",
              display: "inline-block",
              width: "fit-content",
            }}
          >
            {selectedProduct?.type
              ? `${selectedProduct?.type?.toLowerCase()?.charAt(0)?.toUpperCase()}${selectedProduct?.type.toLowerCase().slice(1)} Restock`
              : "N/A"}
          </p>
        </div>
        <div>
          <p className="small-text-size">Restock Amount:</p>
          <p className="small-text-size dark--text font-weight-normal mt-2">
            {formatCurrency({
              value: selectedProduct?.total ? selectedProduct?.total : 0,
              currencyCode: businessDetails?.currency_code,
            })}
          </p>
        </div>
        <div>
          <p className="small-text-size">Supplier:</p>
          <p className="small-text-size dark--text font-weight-normal mt-2">
            {selectedProduct?.suppliers?.length > 1 ? (
              <span>
                <secondaryComponents.ToolTip
                  placeholderContent="Multiple Supplier"
                  showInfoIcon
                  useContentStyling
                  useWideContent
                  contentStyles={{
                    width: "100%",
                    maxWidth: "300px",
                    minWidth: "200px",
                    padding: "15px",
                  }}
                >
                  <span
                    className={`${globalStyles.rowSpaceBetween} ${globalStyles.borderBottom} pb-2`}
                  >
                    <p className="small-text-size">Supplier Name</p>
                  </span>

                  {/* Store list */}
                  <span>
                    {selectedProduct?.suppliers?.map((supplier) => (
                      <div
                        className={`${globalStyles.rowSpaceBetween} ${globalStyles.borderBottom} pt-2 pb-2 cursor-pointer`}
                        key={uuidv4()}
                        onClick={() => handleViewSupplier(supplier?.id)}
                      >
                        <p className="smallest-text-size purple--text">
                          {truncateString(supplier?.name, 20)}
                        </p>
                      </div>
                    ))}
                  </span>
                </secondaryComponents.ToolTip>
              </span>
            ) : (
              <span
                className={`small-text-size dark--text font-weight-normal ${
                  selectedProduct?.suppliers?.[0]?.name
                    ? "cursor-pointer purple--text"
                    : ""
                }`}
                onClick={
                  selectedProduct?.suppliers?.[0]?.name
                    ? () =>
                        handleViewSupplier(selectedProduct?.suppliers[0]?.id)
                    : undefined
                }
              >
                {selectedProduct?.suppliers?.[0]?.name || "N/A"}
              </span>
            )}
          </p>
        </div>
        <div>
          <p className="small-text-size">Order Number:</p>
          <p className="small-text-size dark--text font-weight-normal mt-2">
            {selectedProduct?.order_number || "N/A"}
          </p>
        </div>

        <div>
          <p className="small-text-size">GR Number:</p>
          {selectedProduct?.goods_received?.gr_number ? (
            <Link
              to={pathConstants.INVENTORY_GOODS_RECEIVED_DETAILS({
                id: selectedProduct?.goods_received?.id,
              })}
              className="small-text-size purple--text font-weight-normal mt-2"
            >
              {selectedProduct?.goods_received?.gr_number || "N/A"}
            </Link>
          ) : (
            <p className="small-text-size dark--text font-weight-normal mt-2">
              N/A
            </p>
          )}
        </div>

        <div>
          <p className="small-text-size">PO Number:</p>
          {selectedProduct?.purchase_order?.po_number ? (
            <Link
              to={pathConstants.INVENTORY_PURCHASE_ORDER_DETAILS({
                id: selectedProduct?.purchase_order?.id,
              })}
              className="small-text-size purple--text font-weight-normal"
            >
              {selectedProduct?.purchase_order?.po_number || "N/A"}
            </Link>
          ) : (
            <p className="small-text-size dark--text font-weight-normal">N/A</p>
          )}
        </div>

        <div>
          <p className="small-text-size">Bill Number:</p>
          {selectedProduct?.bills?.length > 0 ? (
            <>
              {selectedProduct?.bills?.map((bill) => (
                <>
                  <Link
                    key={bill?.id}
                    to={pathConstants.INVENTORY_BILLS_DETAILS({
                      id: bill?.id,
                    })}
                    className="small-text-size purple--text font-weight-normal mt-2"
                  >
                    {bill?.bill_number || "N/A"}
                  </Link>
                  ,
                </>
              ))}
            </>
          ) : (
            <p className="small-text-size dark--text font-weight-normal mt-2">
              N/A
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
